import {
	RESET_PUBLIC_CALENDAR,
	SET_PUBLIC_CALENDAR_BOOTSTRAP,
	SET_PUBLIC_CALENDAR_ERROR,
	SET_PUBLIC_CALENDAR_LOADING,
} from '@/store/mutation-types'

export default {
	[RESET_PUBLIC_CALENDAR](state) {
		state.bootstrapped = false
		state.calendars = []
		state.error = false
		state.linkedPartners = []
		state.loading = false
		state.officeHoursStatus = null
		state.officeNumber = null
		state.partnerName = null
		state.shortId = null
		state.timezone = null
	},

	[SET_PUBLIC_CALENDAR_BOOTSTRAP](state, payload) {
		state.bootstrapped = true
		state.calendars = payload.calendars || []
		state.error = false
		state.linkedPartners = payload.linkedPartners || []
		state.officeHoursStatus = payload.officeHoursStatus
		state.officeNumber = payload.officeNumber
		state.partnerName = payload.partnerName
		state.shortId = payload.shortId
		state.timezone = payload.timezone
	},

	[SET_PUBLIC_CALENDAR_ERROR](state, error) {
		state.error = error
	},

	[SET_PUBLIC_CALENDAR_LOADING](state, loading) {
		state.loading = loading
	},
}
